import React from 'react';

import { Container, Label } from '../InformationBlocks.styled';

interface Props {
    label: string;
    text: string;
}

const ProfessionalCDP: React.FC<Props> = ({ label, text }) => {
    return (
        <Container>
            <Label>
                {label}: <strong>{text}</strong>
            </Label>
        </Container>
    );
};

export default ProfessionalCDP;
